/* DD Pawn Loans — canonical site nav + live ticker (one source of truth for every page).
 * Desktop: full horizontal bar (identical to the homepage). Mobile: same menu behind a hamburger drawer.
 * Usage: theme asset, loaded `defer` by layout/theme.liquid on overlay pages.
 *   If #dd-nav is already in the HTML (snippets/dd-nav-static.liquid) it only binds; otherwise it
 *   prepends the ticker+nav to <body> (or #ddx-page if present). Either way it fetches live gold/silver.
 *   Pages must NOT include their own inline ticker/nav (this replaces it).
 */
(function () {
  /* v2 (2026-09-23): if the theme already server-rendered #dd-nav (snippets/dd-nav-static.liquid)
   * we only bind behaviour; the legacy flag is still set so older copies of this file exit. */
  if (window.__ddNavBound) return; window.__ddNavBound = true; window.__ddNavMounted = true;
  var WORKER = 'https://dd-pawn-intake.bearvisualsllc.workers.dev';
  var PRICE = 'https://gold-price.bearvisualsllc.workers.dev/';
  var LINKS = [
    ['🔥 Spot Deals', '/pages/spot-deals'],
    ['Chains', '/collections/gold-chains'], ['Pendants', '/collections/pendants'],
    ['Rings', '/collections/rings'], ['Bracelets', '/collections/bracelets'],
    ['Sell Gold', '/pages/sell-gold-by-mail'], ['Get a Loan', '/pages/collateral-loans'],
    ['Gold Estimator', '/pages/gold-estimator'], ['Gold Report', '/pages/gold-silver-prices'],
    ['Sell Silver', '/pages/sell-silver-pompano-beach'], ['Diamonds', '/pages/sell-diamonds-pompano-beach'],
    ['Contact', '/pages/contact']
  ];

  function css() {
    if (document.getElementById('dd-nav-css')) return;
    var s = document.createElement('style'); s.id = 'dd-nav-css';
    s.textContent = [
      "#dd-nav{position:sticky;top:0;z-index:2147483000;font-family:Archivo,system-ui,sans-serif}",
      /* keep Shopify Inbox live-chat (z 2147483000) visible above the full-screen page overlay */
      "#ddx-page{z-index:2147482000 !important}",
      "#dd-nav a{text-decoration:none}",
      /* ticker */
      "#dd-tk{display:flex;align-items:center;gap:16px;height:40px;padding:0 16px;background:#050506;border-bottom:1px solid rgba(245,197,66,.25);font-family:'IBM Plex Mono',monospace;font-size:12px;color:#F7F3EA;overflow-x:auto;white-space:nowrap;-webkit-overflow-scrolling:touch;scrollbar-width:none}",
      "#dd-tk::-webkit-scrollbar{display:none}",
      "#dd-tk .live{display:flex;align-items:center;gap:6px;color:#2ECC71;font-weight:600;flex:none}",
      "#dd-tk .live i{width:7px;height:7px;border-radius:50%;background:#2ECC71;display:inline-block;animation:ddtk 1.6s infinite}",
      "@keyframes ddtk{0%,100%{opacity:1}50%{opacity:.25}}",
      "#dd-tk b{color:#F5C542}#dd-tk .mut{color:rgba(247,243,234,.5)}",
      "#dd-tk .cta{margin-left:auto;color:#F5C542;font-weight:600;flex:none}",
      /* nav */
      "#dd-bar{display:flex;align-items:center;gap:20px;height:66px;padding:0 18px;background:#0B0B0D;border-bottom:1px solid rgba(247,243,234,.07)}",
      "#dd-bar .logo{flex:none;display:block}#dd-bar .logo img{height:32px;width:auto;display:block}",
      "#dd-bar .shop{flex:none;display:inline-flex;align-items:center;gap:6px;padding:8px 15px;border:1px solid rgba(245,197,66,.6);border-radius:8px;background:linear-gradient(100deg,rgba(245,197,66,.14),rgba(184,134,11,.08));color:#F5C542;font-weight:700;font-size:13px;letter-spacing:.02em}",
      "#dd-bar .links{display:flex;align-items:center;gap:17px;font-size:12.5px;font-weight:500;overflow-x:auto;scrollbar-width:none}",
      "#dd-bar .links::-webkit-scrollbar{display:none}",
      "#dd-bar .links a{color:rgba(247,243,234,.78);white-space:nowrap}#dd-bar .links a:hover{color:#F5C542}",
      "#dd-bar .links a[href='/pages/spot-deals']{color:#F5C542;font-weight:700}",
      "#dd-draw a[href='/pages/spot-deals']{color:#F5C542;font-weight:700}",
      "#dd-bar .right{margin-left:auto;display:flex;align-items:center;gap:14px;flex:none}",
      "#dd-bar .ph{font-family:'IBM Plex Mono',monospace;font-size:12px;color:#F5C542;white-space:nowrap}",
      "#dd-bar .est{display:inline-flex;align-items:center;height:40px;padding:0 18px;background:linear-gradient(100deg,#F5C542,#e0a92c);color:#0B0B0D;font-size:13px;font-weight:700;border-radius:8px;white-space:nowrap}",
      "#dd-bar .est-shop{display:none;background:linear-gradient(100deg,#FF3B30,#C4161C);color:#fff;font-size:15px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;padding:0 24px;box-shadow:0 0 0 1px rgba(255,255,255,.18),0 4px 14px rgba(255,59,48,.4);animation:ddshop 2.4s ease-in-out infinite}@keyframes ddshop{0%,100%{box-shadow:0 0 0 1px rgba(255,255,255,.18),0 4px 14px rgba(255,59,48,.4)}50%{box-shadow:0 0 0 1px rgba(255,255,255,.32),0 4px 24px rgba(255,59,48,.85)}}@media(prefers-reduced-motion:reduce){#dd-bar .est-shop{animation:none}}",
      "#dd-burger{display:none;flex:none;width:42px;height:42px;border:1px solid rgba(245,197,66,.4);border-radius:8px;background:transparent;cursor:pointer;align-items:center;justify-content:center}",
      "#dd-burger span{display:block;width:18px;height:2px;background:#F5C542;position:relative}#dd-burger span::before,#dd-burger span::after{content:'';position:absolute;left:0;width:18px;height:2px;background:#F5C542}#dd-burger span::before{top:-6px}#dd-burger span::after{top:6px}",
      /* drawer */
      "#dd-draw{position:fixed;inset:0;z-index:2147483001;background:rgba(5,5,6,.75);backdrop-filter:blur(4px);display:none;opacity:0;transition:opacity .2s}",
      "#dd-draw.on{display:block;opacity:1}",
      "#dd-draw .panel{position:absolute;top:0;right:0;bottom:0;width:min(320px,86vw);background:#0B0B0D;border-left:1px solid rgba(245,197,66,.3);padding:18px;display:flex;flex-direction:column;gap:4px;transform:translateX(100%);transition:transform .25s;overflow-y:auto}",
      "#dd-draw.on .panel{transform:none}",
      "#dd-draw .x{align-self:flex-end;width:40px;height:40px;border:none;background:transparent;color:#F7F3EA;font-size:24px;cursor:pointer;line-height:1}",
      "#dd-draw a{display:block;padding:14px 10px;color:#F7F3EA;font-size:16px;border-bottom:1px solid rgba(247,243,234,.08)}",
      "#dd-draw a.shopm{color:#F5C542;font-weight:700}",
      "#dd-draw .estm{margin-top:14px;display:flex;align-items:center;justify-content:center;height:52px;background:linear-gradient(100deg,#F5C542,#e0a92c);color:#0B0B0D;font-weight:700;border-radius:8px}",
      "#dd-draw .phm{margin-top:10px;text-align:center;font-family:'IBM Plex Mono',monospace;color:#F5C542;padding:8px}",
      /* responsive: hide desktop links under 1024, full mobile under 760 */
      "@media(max-width:1023px){#dd-bar .links,#dd-bar .ph,#dd-bar .shop,#dd-bar .est-estimate{display:none}#dd-bar .est-shop{display:inline-flex}#dd-burger{display:flex}}",
      "@media(min-width:1024px){#dd-draw{display:none !important}}",
      "@media(max-width:759px){#dd-bar{gap:12px;padding:0 14px}#dd-tk{gap:12px;font-size:11px}#dd-bar .est{padding:0 14px;font-size:12px}#dd-bar .est-shop{padding:0 22px;font-size:15px}}"
    ].join('');
    document.head.appendChild(s);
  }

  function build() {
    if (document.getElementById('dd-nav')) { bind(); return; }
    css();
    var linksHtml = LINKS.map(function (l) { return '<a href="' + l[1] + '">' + l[0] + '</a>'; }).join('');
    var drawerLinks = '<a class="shopm" href="/collections">💍 Shop Gold</a>' +
      LINKS.map(function (l) { return '<a href="' + l[1] + '">' + l[0] + '</a>'; }).join('');
    var nav = document.createElement('div'); nav.id = 'dd-nav';
    nav.innerHTML =
      '<div id="dd-tk">' +
        '<span class="live"><i></i>LIVE</span>' +
        '<span>GOLD <b id="dd-gold">—</b>/oz <span id="dd-gd" style="color:#2ECC71"></span></span>' +
        '<span class="mut" id="dd-gram"></span>' +
        '<span>SILVER <b id="dd-silver" style="color:#F7F3EA">—</b>/oz <span id="dd-sd" style="color:#2ECC71"></span></span>' +
        '<span class="mut" id="dd-upd"></span>' +
        '<a class="cta" href="/pages/gold-estimator">What is yours worth? →</a>' +
      '</div>' +
      '<div id="dd-bar">' +
        '<a class="logo" href="/" aria-label="DD Pawn Loans home"><img src="' + (window.DDX_LOGO||(WORKER+'/assets/logo-full.png')) + '" alt="DD Pawn Loans"></a>' +
        '<a class="shop" href="/collections">💍 Shop Gold</a>' +
        '<nav class="links">' + linksHtml + '</nav>' +
        '<div class="right">' +
          '<a class="ph" href="tel:+15617749292">(561) 774-9292</a>' +
          '<a class="est est-estimate" href="/pages/gold-estimator">Estimate My Gold</a>' +
          '<a class="est est-shop" href="/collections" aria-label="Shop all collections">SHOP</a>' +
          '<button id="dd-burger" aria-label="Open menu"><span></span></button>' +
        '</div>' +
      '</div>' +
      '<div id="dd-draw"><div class="panel"><button class="x" aria-label="Close">×</button>' + drawerLinks +
        '<a class="estm" href="/pages/gold-estimator">Estimate My Gold</a>' +
        '<a class="phm" href="tel:+15617749292">Call (561) 774-9292</a>' +
      '</div></div>';
    var mount = document.getElementById('ddx-page') || document.body;
    mount.insertBefore(nav, mount.firstChild);
    bind();
  }

  function bind() {
    var draw = document.getElementById('dd-draw');
    if (!draw) return;
    document.getElementById('dd-burger').onclick = function () { draw.classList.add('on'); document.body.style.overflow = 'hidden'; };
    function close() { draw.classList.remove('on'); document.body.style.overflow = ''; }
    draw.querySelector('.x').onclick = close;
    draw.onclick = function (e) { if (e.target === draw) close(); };

    loadPrice();
    setInterval(loadPrice, 60000);
  }

  function money(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  var openGold = null, openSilver = null;
  function loadPrice() {
    fetch(PRICE).then(function (r) { return r.json(); }).then(function (d) {
      var g = parseFloat(d.price_oz), s = parseFloat(d.silver_oz);
      if (g > 0) {
        if (openGold === null) openGold = g;
        document.getElementById('dd-gold').textContent = money(g);
        document.getElementById('dd-gram').textContent = money(g / 31.1035) + '/g';
        setDelta('dd-gd', g, openGold);
      }
      if (s > 0) {
        if (openSilver === null) openSilver = s;
        document.getElementById('dd-silver').textContent = money(s);
        setDelta('dd-sd', s, openSilver);
      }
      var t = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'America/New_York' });
      document.getElementById('dd-upd').textContent = 'UPDATED ' + t + ' ET';
    }).catch(function () {});
  }
  function setDelta(id, cur, open) {
    var el = document.getElementById(id); if (!el) return;
    var pct = ((cur - open) / open) * 100, up = pct >= 0;
    el.textContent = (up ? '▲ +' : '▼ ') + pct.toFixed(1) + '%';
    el.style.color = up ? '#2ECC71' : '#E74C3C';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
